import { useGeoPi } from "@/context/GeoPiContext";
import { GeoPiWordmark, GeoPiMark } from "@/components/GeoPiLogo";

export default function GeoPiButton({ className = "", project = null, compact = false }) {
  const { setOpen, setProject } = useGeoPi();
  const onClick = () => { setProject(project); setOpen(true); };
  if (compact) {
    return (
      <button onClick={onClick} data-testid="geopi-open" title="Ask GeoPi"
        className={`inline-flex items-center gap-1.5 rounded-full border border-slate-200 bg-white hover:border-teal-400 pl-1.5 pr-3 py-1 transition-all ${className}`}>
        <GeoPiMark size={20} />
        <span className="font-display font-extrabold text-[13px] text-[#1e293b]">GeoPi</span>
      </button>
    );
  }
  return (
    <button onClick={onClick} data-testid="geopi-open" title="Ask GeoPi"
      className={`inline-flex items-center gap-2 rounded-full border border-slate-200 bg-white hover:border-teal-400 hover:shadow-sm pl-2.5 pr-3.5 py-1.5 transition-all ${className}`}>
      <GeoPiWordmark markSize={22} />
    </button>
  );
}
